<template lang="pug">
    nav#backend-navbar-primary.navbar.navbar-expand-lg.navbar-light.navbar-primary.navbar-vertical(:class="open?'open':''")
      .container
        a.navbar-brand.navbar-brand-autodark.d-none-navbar-horizontal(href='.')
          h2 Portal
        .navbar-collapse.collapse.show
          h6.navbar-heading Navigation
          ul.navbar-nav
            li.nav-item(v-if="user.user.permissions.includes('dashboard:view')")
              router-link.nav-link(to="/dashboard")
                span.nav-link-icon
                  i.feather-home
                span.nav-link-title Home
            //- li.nav-item(v-if="$page.auth.user.perms.includes('company_view')")
            //-   inertia-link.nav-link(:href='route("companies.index")')
            //-     span.nav-link-icon
            //-       i.feather-grid
            //-     span.nav-link-title Companies
            li.nav-item(v-if="user.user.permissions.includes('admin:user:view')")
              router-link.nav-link(:to='{name: "users.index"}')
                span.nav-link-icon
                  i.feather-user
                span.nav-link-title Users
            li.nav-item(v-if="user.user.permissions.includes('admin:role:view')")
              router-link.nav-link(:to='{name: "roles.index"}')
                span.nav-link-icon
                  i.feather-sliders
                span.nav-link-title Roles
            li.nav-item(v-if="user.user.permissions.includes('admin:startup:view')")
              router-link.nav-link(:to='{name: "startups.index"}')
                span.nav-link-icon
                  i.feather-sliders
                span.nav-link-title Startups
            li.nav-item(v-if="user.user.permissions.includes('admin:product:view')")
              router-link.nav-link(:to='{name: "products.index"}')
                span.nav-link-icon
                  i.feather-sliders
                span.nav-link-title Products
            li.nav-item(v-if="user.user.permissions.includes('admin:industry:view')")
              router-link.nav-link(:to='{name: "industry.index"}')
                span.nav-link-icon
                  i.feather-sliders
                span.nav-link-title Industries
            li.nav-item(v-if="user.user.permissions.includes('admin:association:view')")
              router-link.nav-link(:to='{name: "association.index"}')
                span.nav-link-icon
                  i.feather-sliders
                span.nav-link-title Associations
            li.nav-item(v-if="user.user.permissions.includes('admin:corporate:view')")
              router-link.nav-link(:to='{name: "corporate.index"}')
                span.nav-link-icon
                  i.feather-sliders
                span.nav-link-title Corporate
            li.nav-item(v-if="user.user.permissions.includes('admin:challenge:view')")
              router-link.nav-link(:to='{name: "challenges.index"}')
                span.nav-link-icon
                  i.feather-sliders
                span.nav-link-title Challenges
            li.nav-item(v-if="user.user.permissions.includes('admin:event:view')")
              router-link.nav-link(:to='{name: "event.index"}')
                span.nav-link-icon
                  i.feather-sliders
                span.nav-link-title Events
            li.nav-item(v-if="user.user.permissions.includes('admin:week:view')")
              router-link.nav-link(:to='{name: "week.index"}')
                span.nav-link-icon
                  i.feather-sliders
                span.nav-link-title Weeks
            li.nav-item(v-if="user.user.permissions.includes('admin:testimonial:view')")
              router-link.nav-link(:to='{name: "testimonial.index"}')
                span.nav-link-icon
                  i.feather-sliders
                span.nav-link-title Testimonial
            li.nav-item(v-if="user.user.permissions.includes('admin:pitch:view')")
              router-link.nav-link(:to='{name: "pitch.index"}')
                span.nav-link-icon
                  i.feather-sliders
                span.nav-link-title Pitch
            li.nav-item(v-if="user.user.permissions.includes('admin:partner:view')")
              router-link.nav-link(:to='{name: "partner.index"}')
                span.nav-link-icon
                  i.feather-sliders
                span.nav-link-title Partner
            li.nav-item(v-if="user.user.permissions.includes('startups:product:view')")
              router-link.nav-link(:to='{name: "startup.products.index"}')
                span.nav-link-icon
                  i.feather-sliders
                span.nav-link-title Products
            li.nav-item(v-if="user.user.permissions.includes('profile:industry:save')")
              router-link.nav-link(:to='{name: "profile.industry"}')
                span.nav-link-icon
                  i.feather-sliders
                span.nav-link-title Profile
            li.nav-item(v-if="user.user.permissions.includes('profile:association:save')")
              router-link.nav-link(:to='{name: "profile.association"}')
                span.nav-link-icon
                  i.feather-sliders
                span.nav-link-title Profile
            li.nav-item(v-if="user.user.permissions.includes('profile:startup:save')")
              router-link.nav-link(:to='{name: "profile.startup"}')
                span.nav-link-icon
                  i.feather-sliders
                span.nav-link-title Profile
            li.nav-item(v-if="user.user.permissions.includes('admin:form:view')")
              router-link.nav-link(:to='{name: "form.index"}')
                span.nav-link-icon
                  i.feather-sliders
                span.nav-link-title Forms
            
            li.nav-item(v-if="false")
              a.nav-link.dropdown-toggle(href='#navbar-base' data-toggle='dropdown' role='button' aria-expanded='false')
                span.nav-link-icon
                  svg.icon(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
                    line(x1='16.5' y1='9.4' x2='7.5' y2='4.21')
                    path(d='M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z')
                    polyline(points='3.27 6.96 12 12.01 20.73 6.96')
                    line(x1='12' y1='22.08' x2='12' y2='12')
                span.nav-link-title Base
              ul.dropdown-menu.dropdown-menu-arrow.dropdown-menu-columns.dropdown-menu-columns-2
                li
                  a.dropdown-item(href='./empty.html')
                    | Empty page
                li
                  a.dropdown-item(href='./blank.html')
                    | Blank page
                li
                  a.dropdown-item(href='./buttons.html')
                    | Buttons        
          .navbar-side
            .ml-auto.d-none-navbar-vertical-narrow
              h5.text-center.m-0 {{user.user.name}} - {{user.user.role}}
            button.btn.btn-primary.btn-block(@click="logoutAction()")
              i.feather-log-out
              | Logout
          
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  data(){
    return{
      
    }
  },
  computed:{
    ...mapState('auth', ['user']),
    ...mapState('menu', ['open'])
  },
  methods:{
    logoutAction(){
      this.logout(this);
    },
    ...mapActions('auth', ['logout'])
  }
}
</script>

<style lang="scss" scoped>

@media (max-width: 64rem) {
  #backend-navbar-primary.navbar-vertical.navbar-expand-lg {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    width: 15.625rem;
    z-index: 1030;
    min-height: auto;
    align-items: start;
    overflow: auto;
    transition: all .5s ease;
    transform: translateX(-250px);
    &.open {
      transform: translateX(0px);
      backdrop-filter: blur(2px);
    }
    &:not(.navbar-vertical-narrow) .dropdown-menu {
      position: static;
      background: inherit;
      border: 0;
      box-shadow: none;
      padding: 0;
      margin: 0;
      color: inherit;
      -moz-columns: 1;
      columns: 1;
    }
    .navbar-side {
      margin-left: 0;
      margin-top: auto;
      padding-left: 0;
      padding-top: 1rem;
    }
    .navbar-brand {
      display: flex !important;
      width: 100%;
      margin: 0;
      text-align: center;
      height: 3.5rem;
      align-items: center;
      justify-content: center;
    }
    .navbar-heading {
      font-size: .7333333em;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: .04em;
      color: #868c97;
      display: block;
      margin-bottom: .5rem;
    }
    .navbar-collapse {
      flex-direction: column;
      text-align: left;
      align-items: normal;
      padding: 1rem 1rem;
    }
    .navbar-nav {
      flex-direction: column;
      align-items: normal;
      margin-left: -1rem;
      margin-right: -1rem;
      .nav-link {
        min-height: 0;
        height: 2.5rem;
        padding-left: 1rem;
        padding-right: 1rem;
      }
    }
  }
}
</style>